import React, { createContext, useContext, useEffect } from 'react';

const THEME_ID = 'theme-elegant-minimal';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.body.classList.add(THEME_ID);
  }, []);

  return (
    <ThemeContext.Provider value={{ activeTheme: THEME_ID }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
};
